// extracted by mini-css-extract-plugin
module.exports = {"modalBtn":"styles_modalBtn__2fTjm","file":"styles_file__2xVgx"};